<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      Kullanıcı Rol Ekle
    </button>

    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td>Rol Adı</td>
          <td>Tehlike Sınıfı</td>
          <td>İşlemler</td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="val in data" v-bind:key="val.id">
          <td>{{val.roleName}}</td>
          <td>{{ val.dangerType ? val.dangerType  : '' }}</td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#RoleDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            <div class="modal fade" id="RoleDeleteModal" tabindex="-1" aria-labelledby="RoleDeleteModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="RoleDeleteModalLabel">Silme Onayı</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="RoleDelete(deleteId)">Evet, Sil</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>


        </tbody>
      </table>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Rol Ekle</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Rol Adı</label>
              <input type="text" class="form-control" v-model="items.roleName" id="exampleFormControlInput1" placeholder="Kategori Adı">
            </div>

            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="items.isExpert">
              <label class="form-check-label" for="flexSwitchCheckDefault">İş Güvenliği Uzmanı Mı ?</label>
            </div>

            <div v-if="items.isExpert">
              <label for="exampleFormControlInput2" class="form-label">Sınıf</label>
              <select class="form-select" aria-label="Tehlike Sınıfı" v-model="items.dangerType">
                <option v-for="(dangerTypes, index) in dangerTypeData" :key="index" :value="index">
                  {{ dangerTypes }}
                </option>
              </select>
            </div>


          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveItems">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-nocheck
import apiClient from "@/axios";
export default {
  name: "Users",
  data() {
    return {
      deleteId:null,
      isMainCompany: false,
      data:[],
      dangerTypeData:[],
      items:{
        dangerType : null,
      },
      isExpert: false,
    };
  },
  created() {
    this.getData();
    this.getDangerTypes();
  },
  watch: {
    "items.isExpert"(newValue) {
      if (!newValue) {
        this.items.dangerType = null;
      }
    }
  },
  methods:{
    setDeleteId(id) {
      this.deleteId = id;
    },
    RoleDelete(id){
      apiClient.delete(`/definition-personal-roles/${id}`)
          .then(() => {
            this.getData();
          })
          .catch(error => {
            if (error.response && error.response.status === 400) {
              alert(error.response.data);
            } else {
              console.error("Silme işlemi sırasında hata oluştu:", error);
            }
          });
    },
    getDangerTypes(){
      apiClient.get('/danger-types').then(res => {
        this.dangerTypeData = res.data;
      })
    },
    getData(){
      apiClient.get('/definition-personal-roles').then(res => {
        this.data = res.data;
      })
    },
    saveItems(){
      apiClient.post('/definition-personal-roles', this.items).then(res => {
        if(res.data){
          this.getData();
        }
      })
    }

  }

}
</script>

<style scoped>

</style>